import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './style.css'
import '@fortawesome/fontawesome-free/css/all.css'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { handleEnvironmentRedirect, hasUserDismissedRedirect } from './utils/environmentRedirect'
import { useDashboardApi } from './services/dashboardApi'
import { usePerformanceMonitor } from './services/performanceMonitor'
import { useThemeStore } from './stores/theme'

const app = createApp(App)
const pinia = createPinia()

const toastOptions = {
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false
}

// Initialize Pinia first
app.use(pinia)
// Then use router
app.use(router)
app.use(Toast, toastOptions)

// Handle environment redirect before mounting the app
async function initializeApp() {
  try {
    // Check for environment redirect only if user hasn't dismissed it
    if (!hasUserDismissedRedirect()) {
      await handleEnvironmentRedirect()
    }

    // Initialize theme store with proper error handling
    console.log('[Main] Initializing theme store...')
    try {
      const themeStore = useThemeStore()
      themeStore.initialize()
      console.log('[Main] Theme store initialized successfully')
    } catch (themeError) {
      console.error('[Main] Theme store initialization failed:', themeError)
      // Continue with app initialization even if theme fails
    }

    // Mount the app after redirect check
    app.mount('#app')

  } catch (error) {
    console.error('[Main] Error during app initialization:', error)
    // Mount the app anyway if redirect fails
    app.mount('#app')
  }
}

// Unregister any existing service workers to prevent conflicts
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      console.log('[Main] Unregistering service worker:', registration.scope)
      registration.unregister()
    })
  }).catch(error => {
    console.warn('[Main] Error unregistering service workers:', error)
  })
}

// Initialize the application
initializeApp()
